import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectProjectId } from '../../selectors';
import { trackPhoneOpen } from '../../utils/analytics';
import { CallButtonContainer } from '../CallButtonContainer';
import { CallbackButtonWrapper } from '../../components/CallbackButtonWrapper';
import { CallbackContainer } from '../CallbackContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

export const StickyCallbackButtonContainer = () => {
  const projectId = useSelector(selectProjectId);

  const handlePhoneClick = useEventCallback(() => {
    trackPhoneOpen('Open_CSP_card_floating_block', projectId);
  });

  return (
    <CallbackButtonWrapper>
      <CallButtonContainer size="M" theme="fill_primary" fullWidth onCallClick={handlePhoneClick} />
      <CallbackContainer placement={ECallbackWidgetPlacement.Author} />
    </CallbackButtonWrapper>
  );
};
